export const generateAIDescription = async (
  title: string,
  message: string,
  dummy: boolean = true,
): Promise<string> => {
  if (!dummy) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/artifacts/generateAIText`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ title, message }),
        },
      )
      const res = await response.json()

      return res.data
    } catch (error) {
      console.error('Error:', error)

      return 'Error fetching response'
    }
  } else {
    return 'This content is crafted by AI to provide a detailed analysis of the chart, offering insights and interpretations to enhance understanding'
  }
}
